import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSmsContactsQueryKey } from "./useSmsContactsQuery";
import { gatewayPhone } from "src/gateways/gatewayPhone";

const markAsRead = async (sessionNumber: string, phoneNumber: string) => {
    await gatewayPhone.patch(`inbound-records/contacts/read`, {
        fromNumber: sessionNumber,
        contactPhoneNumber: phoneNumber,
    });
};

export const useMarkAsRead = (sessionNumber?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (phoneNumber: string) =>
            markAsRead(sessionNumber || "", phoneNumber),
        onSuccess: (_, phoneNumber) => {
            queryClient.setQueryData(
                getSmsContactsQueryKey(sessionNumber),
                (oldData: any) => {
                    if (!oldData) return oldData;

                    return {
                        ...oldData,
                        pages: oldData.pages.map((page: any) => ({
                            ...page,
                            data: page.data.map((contact: any) =>
                                contact.phoneNumber === phoneNumber
                                    ? {
                                        ...contact,
                                        unreadCount: 0,
                                    }
                                    : contact,
                            ),
                        })),
                    };
                },
            );
        },
    });
};